import React from 'react';
import ReactDOM from 'react-dom/client';
import './utilis/configureSweetAlert2';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PermissionsProvider } from './utilis/PermissionsContext';

// Create the root and render the App component
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
      <PermissionsProvider>
        <App />
      </PermissionsProvider>
    </BrowserRouter>
);

// Measure performance (optional)
reportWebVitals();
